var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.10271 3.10207C9.42695 1.77783 11.574 1.77783 12.8982 3.10207C14.2224 4.42631 14.2224 6.57332 12.8982 7.89756L8.8982 11.8976C8.12625 12.6695 6.87466 12.6695 6.10271 11.8976C5.33075 11.1256 5.33075 9.87402 6.10271 9.10207L10.1027 5.10207C10.3224 4.8824 10.6785 4.8824 10.8982 5.10207C11.1179 5.32174 11.1179 5.67789 10.8982 5.89756L6.8982 9.89756C6.56559 10.2302 6.56559 10.7695 6.8982 11.1021C7.23082 11.4347 7.77009 11.4347 8.10271 11.1021L12.1027 7.10207C12.9876 6.21717 12.9876 4.78246 12.1027 3.89756C11.2178 3.01266 9.7831 3.01266 8.8982 3.89756L4.8982 7.89756C3.46102 9.33475 3.46102 11.6649 4.8982 13.1021C6.33539 14.5393 8.66552 14.5393 10.1027 13.1021L14.1027 9.10207C14.3224 8.8824 14.6785 8.8824 14.8982 9.10207C15.1179 9.32174 15.1179 9.67789 14.8982 9.89756L10.8982 13.8976C9.02168 15.7741 5.97923 15.7741 4.10271 13.8976C2.22618 12.021 2.22618 8.9786 4.10271 7.10207L8.10271 3.10207Z",
    fill: "#28303F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.ed9cdad6.svg";
export { ForwardRef as ReactComponent };